import { format } from 'date-fns'
import { AvailableHoursDataMapper } from './AvailableHoursMapper.types'

class AvailableHoursMapper {
  toPersistence(domainData: AvailableHoursDataMapper) {
    const dateFormatted =
      domainData?.date && format(new Date(domainData?.date), 'dd/MM/yyyy')

    return {
      data: dateFormatted,
      idPaciente: domainData?.patientId,
      idProfissional: domainData?.professionalId,
      idAtendimento: domainData?.appointmentId,
    }
  }
}

export default new AvailableHoursMapper()
